import {combineReducers} from 'redux'
import userReducer from './userReducer'
import {initialState} from './initialState'

const appReducer = combineReducers({userReducer})

const rootReducer = (state, action) => {
  if (action.type === 'CLEAR_STORE') {
    state = {
      userReducer: {...structuredClone(initialState), isLoading: false},
    }
  }
  return appReducer(state, action)
}

export default rootReducer
